import React from 'react';

import { flagStyles } from '../settings';

const SvgMQ = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3552px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgMQ;
